import {
  CHECK_ZIPCODE_SUCCESSFULLY,
  CHECK_ZIPCODE_FAILED,
  ENQUIRY_SUCCESSFULLY,
  ENQUIRY_FAILED,
  GET_PRICE_LIST_SUCCESSFULLY,
  GET_PRICE_LIST_FAILED,
  GET_QUOTE_SUCCESSFULLY,
  GET_QUOTE_FAILED,
  POST_SERVICE_ORDER_FAILED,
  POST_SERVICE_ORDER_SUCCESSFULLY,
  UPDATE_SERVICE_ORDER_SUCCESSFULLY,
  UPDATE_SERVICE_ORDER_FAILED,
  CLEAR_PRICING_CALC,
  CHECK_EMAIL,
  VERIFY_EMAIL_SUCCESSFULLY,
  VERIFY_EMAIL_FAILED,
  RESIDENTIAL_REGISTER_SUCCESSFULLY,
  RESIDENTIAL_REGISTER_FAILED,
  GET_PREFERRED_DAYS_SUCCESSFULLY,
  GET_PREFERRED_DAYS_FAILED,
  POST_SERVICE_ORDER_INQUIRY_SUCCESSFULLY,
  POST_SERVICE_ORDER_INQUIRY_FAILED,
  UPDATE_SERVICE_ORDER_INQUIRY_SUCCESSFULLY,
  UPDATE_SERVICE_ORDER_INQUIRY_FAILED,
  CREATE_LEAD_SUCCESSFULLY,
  GET_LEAD_FAILED,
  GET_LEAD_SUCCESSFULLY,
  CREATE_LEAD_FAILED,
  UPDATE_LEAD_SUCCESSFULLY,
  UPDATE_LEAD_FAILED,
  GET_SERVICE_ORDER_ENQUIRY_SUCCESSFULLY,
  GET_SERVICE_ORDER_ENQUIRY_FAILED,
  HISTORICAL_DATA_FAILED,
  HISTORICAL_DATA_SUCCESS,
  UPDATE_LAST_STEP_SUCCESSFULLY,
  UPDATE_LAST_STEP_FAILED,
  REGISTER_LAST_STEP_SUCCESSFULLY,
  REGISTER_LAST_STEP_FAILED,
  GET_LAST_STEP_UUID_SUCCESSFULLY,
  GET_LAST_STEP_UUID_FAILED
} from './types';
import axiosInstance from '../Lib/axios';
import {message} from "antd";
import axios from 'axios';
import config from '../Lib/config';

// check if email is already in use
export const checkEmail = email => dispatch => {
  return axiosInstance.get(`accounts/check-email?email=${email}`)
    .then(response => dispatch({
      type: CHECK_EMAIL,
      payload: response.data.already_exists
    }))
    .catch(() => dispatch({
      type: CHECK_EMAIL,
      payload: true
    }));
}

// Check if email is already in use and return user info
export const verifyEmail = (email) => {
  return (dispatch) => {
    return axiosInstance.
      get(`accounts/user-email-lead?email=${email}`)
      .then(response => 
        dispatch({ 
          type: VERIFY_EMAIL_SUCCESSFULLY, 
          payload: response.data 
        }))
      .catch((error) => dispatch({ 
        type: VERIFY_EMAIL_FAILED, 
        payload: error.response.data 
      }));
  }
}

export const getHistoricalData = (params) => {
  return (dispatch) => {
    return axiosInstance.post(`accounts/user-email-lead/historical_data/`, params)
      .then((response) => {
        dispatch({ 
          type: HISTORICAL_DATA_SUCCESS,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          dispatch({
            type: HISTORICAL_DATA_FAILED,
            data: error.response.data,
          });
        }
      });
  }
}

// Check zip code is valid or not
export const checkZipCode = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`field-office`, {
        params,
      })
      .then((response) => {
        dispatch({
          type: CHECK_ZIPCODE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          // if (error.response.status === 401 || error.response.status === 403) {}
          dispatch({
            type: CHECK_ZIPCODE_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

//Get Initial CLeaning Days
export const getPreferredDays = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`field-office/initial_cleanning_days`, {
        params,
      })
      .then((response) => {
        dispatch({
          type: GET_PREFERRED_DAYS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          // if (error.response.status === 401 || error.response.status === 403) {}
          dispatch({
            type: GET_PREFERRED_DAYS_FAILED,
            data: error.response.data,
          });
        }
      });
  };
}

// Register last completed step by user
export const registerCustomerLastCompletedStep = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`quote-step-lead/`, params)
      .then((response) => {
        dispatch({ 
          type: REGISTER_LAST_STEP_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          dispatch({
            type: REGISTER_LAST_STEP_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Register last completed step by user
export const getCustomerLastCompletedStepUUID = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`quote-step-lead/get-quote-step-lead`, {params})
      .then((response) => {
        dispatch({ 
          type: GET_LAST_STEP_UUID_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          dispatch({
            type: GET_LAST_STEP_UUID_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Update last completed step by user
export const updateCustomerLastCompletedStep = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`quote-step-lead/${params.tracking_uuid}/`, 
        {step: params.step})
      .then((response) => {
        dispatch({ 
          type: UPDATE_LAST_STEP_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          dispatch({
            type: UPDATE_LAST_STEP_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// non-serviceable-enquiry for email
export const nonServiceableEnquiry = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`non-serviceable-enquiry/`, params)
      .then((response) => {
        dispatch({ 
          type: ENQUIRY_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          // if (
          //     error.response.status === 401 ||
          //     error.response.status === 403
          // ) {}
          dispatch({
            type: ENQUIRY_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

export const getPriceList = (id) => {
  return (dispatch) => {
    return axiosInstance
      .get(
        `field-office/${id}/frequency-pricing-range/`,
        {}
      )
      .then((response) => {
        dispatch({
          type: GET_PRICE_LIST_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error.response) {
          // if (
          //     error.response.status === 401 ||
          //     error.response.status === 403
          // ) {}
          dispatch({
            type: GET_PRICE_LIST_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

export const pricingCalculator = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`pricing-calculator`, params, {})
      .then((response) => {
        dispatch({ type: GET_QUOTE_SUCCESSFULLY, data: response.data });
      })
      .catch((error) => {
        if (error.response) {
          // if (
          //     error.response.status === 401 ||
          //     error.response.status === 403
          // ) {}
          dispatch({
            type: GET_QUOTE_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Get service order information for residential
export const getServiceOrder = (user_uuid) => {
  return (dispatch) => {
    return axiosInstance.get(`service-order-enquiry/?user__uuid=${user_uuid}`, {
    })
      .then(response => {
        dispatch({ 
          type: GET_SERVICE_ORDER_ENQUIRY_SUCCESSFULLY, 
          data: response.data
        });
      })
      .catch(error => {
        dispatch({ 
          type: GET_SERVICE_ORDER_ENQUIRY_FAILED,
          data: error.response.data 
        });
      });
  }
}

// Service Order Create
export const placeOrder = (params) => {
  // store the scorpion_id in user
  let scorpion_id = localStorage.getItem('scorpion_id');
  if (scorpion_id) {
    params["scorpion_id"] = scorpion_id;
  }
  
  return (dispatch) => {
    return axiosInstance.post(`service-order/`, params, {
    })
      .then(response => {
        dispatch({ type: POST_SERVICE_ORDER_SUCCESSFULLY, data: response.data });
      })
      .catch(error => {
        dispatch({ type: POST_SERVICE_ORDER_FAILED, data: error.response.data });
      });
  }
};

// Service Order Create
export const placeOrderInquery = (params) => {
  
  // store the scorpion_id in user
  let scorpion_id = localStorage.getItem('scorpion_id');
  if (scorpion_id) {
    params["scorpion_id"] = scorpion_id;
  }

  params["outreach"] = "website"
  
  return (dispatch) => {
    return axiosInstance.post(`service-order-enquiry/`, params, {
    })
      .then(response => {
        dispatch({ type: POST_SERVICE_ORDER_INQUIRY_SUCCESSFULLY, data: response.data });
      })
      .catch(error => {
        dispatch({ type: POST_SERVICE_ORDER_INQUIRY_FAILED, data: error});
      });
  };
};

// Update Service Order
export const updateOrder = (params, uuid) => {
  return (dispatch) => {
    return axiosInstance.patch(`/service-order/${uuid}/`, params, {
    })
      .then(response => {
        dispatch({ type: UPDATE_SERVICE_ORDER_SUCCESSFULLY, data: response.data });
      })
      .catch(error => {
        if (error.response) {
          dispatch({ type: UPDATE_SERVICE_ORDER_FAILED, data: error.response.data });
        }
      });
  };
};

export const updateOrderInquery = (params, uuid) => {
  return (dispatch) => {
    return axiosInstance.patch(`/service-order-enquiry/${uuid}/`, params, {

    })
      .then(response => {
        dispatch({ type: UPDATE_SERVICE_ORDER_INQUIRY_SUCCESSFULLY, data: response.data });
      })
      .catch(error => {
        if (error.response) {
          dispatch({ type: UPDATE_SERVICE_ORDER_INQUIRY_FAILED, data: error.response.data });
        }
      });
  };
};

export const clearPricingCalc = () => dispatch => {
  dispatch({ type: CLEAR_PRICING_CALC })
}

//Register Residential User
export const residentialRegister = (params) => {
  return async (dispatch) => {
    const djangoToken = JSON.parse(sessionStorage.getItem("orderSubmit"))
      ? JSON.parse(sessionStorage.getItem("orderSubmit")).user_token
      : "";
    return await axios.post(`${config.getHost()}auth/password/change/`, params,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `token ${djangoToken}`,
        },
      })
      .then(response => {
        dispatch({ type: RESIDENTIAL_REGISTER_SUCCESSFULLY, data: response.data });
      })
      .catch(error => {
        if (error.response) {
          // console.log(JSON.parse(sessionStorage.getItem("orderSubmit")))
          dispatch({ type: RESIDENTIAL_REGISTER_FAILED, data: error.response.data });
        }
      });

  };
};

// Get a lead
export const getLeadById = (id) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/lead-user/${id}`)
      .then((response) => {
        dispatch({
          type: GET_LEAD_SUCCESSFULLY,
          data: response?.data,
        });
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.assign("/");
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_LEAD_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};

// Create Lead
export const createLead = (params) => {
  return (dispatch) => {
    return axiosInstance.post(`/crm/lead-user/`, params)
      .then(response => {
        dispatch({ type: CREATE_LEAD_SUCCESSFULLY, data: response.data });
      })
      .catch(error => {
        if (error.response) {
          dispatch({ type: CREATE_LEAD_FAILED, data: error.response.data });
          message.error(error?.response?.data?.email[0])
        }
      });
  };
};

// Update Lead to Customer
export const updateLead = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance.patch(`/crm/lead-user/${uuid}/`, params)
      .then(response => {
        dispatch({ type: UPDATE_LEAD_SUCCESSFULLY, data: response.data });
      })
      .catch(error => {
        if (error.response) {
          dispatch({ type: UPDATE_LEAD_FAILED, data: error.response.data });
        }
      });
  };
};

// Clean Residential/Lead Response
export const cleanResLeadResponse = () => {
  return (dispatch) => {
    dispatch({ type: 'CLEAN_RESIDENTIAL_REGISTER_RESPONSE' });
  }
}